import paperhead from "../assets/0xpaperhead.jpg";
import { QRCodeSVG } from "qrcode.react";

function XLogo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622Zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export default function CTASlide() {
  return (
    <>
      <div className="absolute inset-0 bg-gradient-to-t from-avo-lime/5 to-transparent" />
      <div className="max-w-7xl w-full mx-auto relative z-10 flex flex-col items-center justify-center h-full gap-10">
        {/* Header */}
        <div className="text-center">
          <h1 className="text-6xl font-bold mb-4 leading-tight">
            Avo with{" "}
            <span className="text-avo-lime underline decoration-avo-lime/50 underline-offset-8">
              Miles
            </span>
          </h1>
          <p className="text-gray-300 text-2xl font-medium">
            Use Avo{" "}
            <span className="text-white font-bold">NOW</span>{" "}
            to secure a spot for Miles
          </p>
        </div>

        {/* QR code */}
        <div className="flex flex-col items-center gap-4">
          <div className="relative">
            {/* Glow */}
            <div
              className="absolute -inset-3 bg-avo-lime/20 rounded-3xl"
              style={{ filter: "blur(16px)" }}
            />
            <div className="relative bg-white p-4 rounded-2xl shadow-[0_0_40px_rgba(0,0,0,0.6)]">
              <QRCodeSVG
                value="https://app.avo.so"
                size={180}
                bgColor="#ffffff"
                fgColor="#000000"
                level="M"
              />
            </div>
          </div>
          <span className="text-white font-mono text-base tracking-wide">app.avo.so</span>
        </div>

        {/* X handle card */}
        <a
          href="https://x.com/0xpaperhead"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-5 py-3 hover:bg-white/10 hover:border-white/20 transition-all group"
        >
          <XLogo className="w-5 h-5 text-white group-hover:text-avo-lime transition-colors" />
          <span className="text-white font-semibold text-base">@0xpaperhead</span>
        </a>
      </div>

      {/* Presented by - pinned bottom center */}
      <div className="absolute bottom-8 left-0 right-0 flex justify-center z-10">
        <div className="flex items-center gap-2">
          <span className="text-gray-500 text-sm">Presented by</span>
          <img
            src={paperhead}
            alt="0xPaperhead"
            className="w-6 h-6 rounded-full object-cover border border-white/10"
          />
          <span className="font-bold text-white text-sm">0xPaperhead</span>
        </div>
      </div>
    </>
  );
}
